import { type Actor, can } from '@hrms/shared'
import { LuColumns3, LuHeartHandshake, LuInbox, LuSettings2, LuTicket } from 'react-icons/lu'
import { Navigate } from 'react-router'
import { useCurrentUser } from '../../auth/AuthProvider.tsx'
import { RequirePermission } from '../../auth/guards.tsx'
import type { AppModule } from '../types.ts'
import { HrDeskLayout } from './HrDeskLayout.tsx'
import { BoardPage } from './pages/BoardPage.tsx'
import { MyTicketsPage } from './pages/MyTicketsPage.tsx'
import { TicketsPage } from './pages/TicketsPage.tsx'
import { SettingsPage } from './settings/SettingsPage.tsx'
import { RaiseTicketButton } from './tickets/RaiseTicketButton.tsx'

/** HR team and viewers land on the queue; employees on My tickets. */
const landing = (actor: Actor) => (can(actor, 'queue.view') ? 'tickets' : 'my-tickets')

function HrDeskHome() {
  return <Navigate to={landing(useCurrentUser())} replace />
}

export const hrDeskModule: AppModule = {
  id: 'hr-desk',
  name: 'HR desk',
  icon: LuHeartHandshake,
  color: 'orange',
  basePath: '/hr',
  landing,
  layout: <HrDeskLayout />,
  TopBarAction: RaiseTicketButton,
  navItems: [
    {
      label: 'My tickets',
      path: 'my-tickets',
      icon: LuInbox,
      color: 'blue',
      permission: 'ticket.create.self',
    },
    {
      label: 'Tickets',
      path: 'tickets',
      icon: LuTicket,
      color: 'violet',
      permission: 'queue.view',
    },
    { label: 'Board', path: 'board', icon: LuColumns3, color: 'teal', permission: 'queue.view' },
    {
      label: 'Settings',
      path: 'settings',
      icon: LuSettings2,
      color: 'amber',
      permission: 'settings.view',
    },
  ],
  routes: [
    { index: true, element: <HrDeskHome /> },
    {
      path: 'my-tickets',
      element: (
        <RequirePermission permission="ticket.create.self">
          <MyTicketsPage />
        </RequirePermission>
      ),
    },
    {
      path: 'tickets',
      element: (
        <RequirePermission permission="queue.view">
          <TicketsPage />
        </RequirePermission>
      ),
    },
    {
      path: 'board',
      element: (
        <RequirePermission permission="queue.view">
          <BoardPage />
        </RequirePermission>
      ),
    },
    {
      path: 'settings',
      element: (
        <RequirePermission permission="settings.view">
          <SettingsPage />
        </RequirePermission>
      ),
    },
  ],
}
